import {Dropzone} from "dropzone";

if($('.dropzone').length) {
    const dropzone = new Dropzone(".dropzone", {
        url: "/attachment/upload",
        maxFiles: 10,
        maxFilesize: 10, // MB
        addRemoveLinks: true,
        dictRemoveFileConfirmation: "Are you sure you wish to permanently remove this attachment?",
        accept: function(file, done) {
            done();
        },
        removedfile: function(file) {
            let ticket = $("#ticket-id").val();
            let type = "tickets";
            var name = file.name;
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                type: 'POST',
                url: '/attachment/remove',
                data: {
                    name: name,
                    type: type,
                    ticket: ticket
                },
                success: function(data) {
                }
            });
            var _ref;
            return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
        }
    });
    dropzone.on('addedfile', function(file) {

        var ext = file.name.split('.').pop();

        if(ext === "pdf") {
            $(file.previewElement).find(".dz-image img").attr("src", "/storage/pdf.png");
        } else if(ext.indexOf("doc") !== -1) {
            $(file.previewElement).find(".dz-image img").attr("src", "/storage/word.png");
        } else if(ext.indexOf("xls") !== -1) {
            $(file.previewElement).find(".dz-image img").attr("src", "/storage/excel.png");
        }
        /*// Add a link to download the image
         $(".dz-remove").before("<a href=''>Download</a><br/>");*/
    });
    dropzone.on("error", function(file, message) {
        console.log(message);
    });
}
